import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export type PartnerInvitationContactType = 'EMAIL' | 'SMS';
export type PartnerInvitationPurpose = 'PARTNER_INVITE' | 'PROFIT_LOSS_ANALYSIS';
/** 파트너 초대 생성 요청 */
export interface CreatePartnerInvitationRequest {
  /**
   * @deprecated use `contactValue` instead.
   */
  partnerEmail?: string;
  contactType: PartnerInvitationContactType;
  contactValue: string;
  invitationPurpose: PartnerInvitationPurpose;
}

/** 파트너 초대 응답 */
export interface PartnerInvitationResponse {
  id: number;
  partnerEmail: string;
  createdAt: string;
}

/** 파트너 초대 생성 */
export const createPartnerInvitation = ({
  companyId,
  request,
}: {
  companyId: string;
  request: CreatePartnerInvitationRequest;
}) => {
  return API.post<ResponseBaseWithData<PartnerInvitationResponse>>(
    `/api/v3/companies/${companyId}/partner-invitations`,
    { data: request },
  );
};
